import { render, staticRenderFns } from "./Subscriber.vue?vue&type=template&id=b96be9c0&"
import script from "./Subscriber.vue?vue&type=script&lang=js&"
export * from "./Subscriber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports